export const FUNNEL_LABELS: Record<string, string> = {
  admin: 'Admin',
  event: 'Event',
  scout: 'Privat',
  unknown: 'Unknown',
}

export const SUBTYPE_OPTIONS: { value: string; label: string }[] = [
  { value: 'heatpump', label: 'Heatpump' },
  { value: 'pv', label: 'Photovoltaic' },
]
